
import Vue from 'vue'
import moment from 'moment'
import { validateToken } from "@/utilities/Helpers";

const tokenLocal = localStorage.getItem('user-token') !== null ? JSON.parse(localStorage.getItem('user-token')) : { tokenExpiration: -1 };

const getDefaultState = () => {
    return {
        userToken: tokenLocal || '',
        authenticated: validateToken(tokenLocal.tokenExpiration),
        status: '',
        accessToken: localStorage.getItem('userToken')
    }
};

const state = getDefaultState();

const mutations = {
    resetState: (state) => {
        Object.assign(state, getDefaultState());
    },
    authRequest: (state) => {
        state.status = 'loading'
        state.authenticated = false;
    },
    authSucess: (state, dataToken) => {
        state.status = 'success'
        state.userToken = dataToken
        state.authenticated = validateToken(dataToken.tokenExpiration);
    },
    authError: (state) => {
        state.status = 'error'
        state.authenticated = false;
    },
}

const actions = {
    resetState: ({ commit }) => {
        commit('resetState');
    },
    authentication: ({ commit }, user) => {
        
        Object.assign(user, {
            grant_type: "password",
            client_id: "ro.client",
            scope: "api1",
            client_secret: "secret" 
        });
        
        const userQueryString = Object.keys(user).map(key => key + '=' + user[key]).join('&');  

        //console.log(userQueryString);
        return new Promise((resolve, reject) => {
            commit('authRequest')
            Vue.prototype.$httpIdentityServer.post('connect/token', userQueryString, {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            })
                .then(resp => {
                    const dataToken = resp.data;
                    console.log("dataToken");
                    console.log(dataToken);
                    Object.assign(dataToken, { tokenExpiration: moment().add(dataToken.expires_in, 'seconds') });

                    localStorage.setItem('user-token', JSON.stringify(dataToken))
                    commit('authSucess', dataToken);

                    resolve(resp)
                })
                .catch(err => {
                    commit('authError', err)
                    localStorage.removeItem('user-token')
                    reject(err)
                })
        })
    },
    logout({ commit }) {
        commit('resetState');
        localStorage.removeItem('user-token')
        Vue.prototype.getApp.$router.push({ path: '/login' })
    }
}

const getters = {
    getState: (state) => {
        return state;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


